import { Row, SortingFn, sortingFns } from '@tanstack/react-table';

export function createComputedAlphanumeric<T extends Record<any, any>>(
  computeFn: (row: T) => string
): SortingFn<T> {
  return (rowA: Row<T>, rowB: Row<T>, columnId: string) => {
    return sortingFns.alphanumeric(
      { ...rowA, getValue: () => computeFn(rowA.original) as any },
      { ...rowB, getValue: () => computeFn(rowB.original) as any },
      columnId
    );
  };
}
